import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { UserAchievement } from 'src/app/models/user-achievement.model';
import { AchievementService } from 'src/app/services/achievement.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';
import { WeeklyReportService } from 'src/app/services/weekly-report.service';

@Component({
  selector: 'app-programme-index',
  templateUrl: './programme-index.component.html',
  styleUrls: ['./programme-index.component.scss'],
})
export class ProgrammeIndexComponent implements OnInit {
  daysToSurgery: number | undefined;
  sugeryDateProgress: number | undefined;
  isLoading = false;
  currentWeekNumber!: number;
  userData: any;
  reportsRead: any = [];
  achievements:UserAchievement[] =[];

  constructor(
    private userService: UserService,
    private weeklyReportService: WeeklyReportService,
    private userTaskStatusService: UserTaskStatusService,
    private achievementService:AchievementService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        this.currentWeekNumber =
          moment().diff(moment(userData.date_registered).startOf('week'), 'week') + 1;

        if (userData.surgery_date) {
          var a = moment(moment().format('YYYY-MM-DD'));
          var b = moment(userData.surgery_date);
          this.daysToSurgery = b.diff(a, 'days');

          let totalDaysToSurgery = b.diff(
            moment(userData.date_registered),
            'days'
          );

          this.sugeryDateProgress = Math.round(
            ((totalDaysToSurgery - this.daysToSurgery) / totalDaysToSurgery) *
              100
          );
        }
      }
    });

    forkJoin({
      allTaskStatuses: this.userTaskStatusService.fetchAll(),
      allAchievements: this.achievementService.fetchAll()
    }).subscribe((responseData) => {
      this.achievements = responseData.allAchievements;
      this.reportsRead = this.weeklyReportService.getReportsRead(
        responseData.allTaskStatuses
      );
      this.isLoading = false;
    });
  }

  onShowReport(week: number) {
    this.weeklyReportService.showReport.next(true);
    this.weeklyReportService.activeWeek.next(week);
  }

  countAchievements(type:string){
    let count = 0;
    this.achievements.forEach((achievement)=>{
      if(achievement.type == type){
        count++;
      }
    });
    return count;
  }
}
